import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { GenericMarkerDescription } from 'components-modules/map-slot-generic/index.js';
import { IModule } from 'redux-state/layout/types.js';
import { MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';
import { ILink } from 'types/navigation.js';
import { MarineMarkerDescription, MarineRiskProps } from './marker.description.marine.js';

export type MarineRiskCustom = {
  link?: ILink;
  value: MarineRiskProps;
};

export const PaddleBoardingMarineMapSlot = (props: IModule<MarineRiskCustom & IMapSlotClose>) => {
  return <MarineRiskMapSlot {...props} type={MarkerTypeWaterActivity.Paddleboarding} />;
};

export const KayakMarineMapSlot = (props: IModule<MarineRiskCustom & IMapSlotClose>) => {
  return <MarineRiskMapSlot {...props} type={MarkerTypeWaterActivity.Kayak} />;
};

/** These props are generated
 * 1. When markers area selected
 * 2. in for national park views - tracks / cycles */
const MarineRiskMapSlot = ({
  config,
  modulePath,
  type,
}: IModule<MarineRiskCustom & IMapSlotClose> & {
  type: typeof MarkerTypeWaterActivity.Paddleboarding | typeof MarkerTypeWaterActivity.Kayak;
}) => {
  const { key, value } = config;
  return (
    <GenericMarkerDescription key={key} dataModule="activity-description-comp" config={config} modulePath={modulePath}>
      <MarineMarkerDescription value={value} type={type} />
    </GenericMarkerDescription>
  );
};
